const readString = (name) => {
  const v = import.meta.env[name];
  if (v == null) return '';
  return String(v).trim();
};

const readBool = (name, defaultValue = false) => {
  const v = import.meta.env[name];
  if (v == null) return defaultValue;
  const s = String(v).trim().toLowerCase();
  return s === 'true' || s === '1' || s === 'yes';
};

const requireInProd = (name, value) => {
  if (!import.meta.env.PROD) return;
  if (value) return;
  throw new Error(
    `Missing required environment variable: ${name}. Set it in Vercel (Preview + Production) or in frontend/.env.local for local development.`
  );
};

const normalizeBaseUrl = (value) => {
  const v = (value || '').trim();
  if (!v) return '';
  return v.endsWith('/') ? v.slice(0, -1) : v;
};

const apiBaseUrl = normalizeBaseUrl(readString('VITE_API_BASE_URL'));
requireInProd('VITE_API_BASE_URL', apiBaseUrl);
if (!import.meta.env.PROD && !apiBaseUrl) {
  try {
    console.warn(
      'VITE_API_BASE_URL is not set. Frontend requests will use relative URLs; set VITE_API_BASE_URL in frontend/.env.local for local development.'
    );
  } catch (_) {}
}

export const ENV = Object.freeze({
  mode: import.meta.env.MODE,
  isDev: Boolean(import.meta.env.DEV),
  isProd: Boolean(import.meta.env.PROD),
  apiBaseUrl,
  firebase: Object.freeze({
    apiKey: readString('VITE_FIREBASE_API_KEY'),
    authDomain: readString('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: readString('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: readString('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: readString('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: readString('VITE_FIREBASE_APP_ID'),
    measurementId: readString('VITE_FIREBASE_MEASUREMENT_ID'),
  }),
  stripe: Object.freeze({
    publishableKey: readString('VITE_STRIPE_PUBLISHABLE_KEY'),
  }),
  analytics: Object.freeze({
    tiktokPixelId: readString('VITE_TIKTOK_PIXEL_ID'),
    metaPixelId: readString('VITE_META_PIXEL_ID'),
    debug: readBool('VITE_ANALYTICS_DEBUG', false) || readBool('VITE_PIXEL_DEBUG', false),
    sentryDsn: readString('VITE_SENTRY_DSN'),
  }),
});
